<script>
	import utilities from 'utilities';

	export default {
		mounted() {
			utilities.openModal('#printing-modal');
		}
	};
</script>
